// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"a72e360f","609":"02e0aab5","734":"70a9e551"}[chunkId] + ".chunk.css";
};